import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 7978 11680"
    {...props}
  >
    <path
      d="M7978 5901c0 854-53 1585-157 2197-104 614-295 1170-577 1667-354 612-808 1085-1369 1418-562 332-1186 497-1873 497-787 0-1497-224-2122-670-625-447-1095-1064-1415-1851-159-431-276-910-353-1431C37 7207 0 6643 0 6034c0-784 43-1489 125-2117 82-630 213-1170 388-1622 306-747 753-1316 1335-1707C2433 197 3130 0 3941 0c535 0 1021 88 1458 260 436 176 819 429 1148 764 330 335 609 750 838 1242 396 856 593 2069 593 3635zm-2138-154c0-950-56-1729-170-2332-115-607-309-1064-577-1373-272-308-647-462-1123-462-686 0-1162 345-1430 1037-269 688-402 1752-402 3191 0 976 56 1776 170 2399 115 625 309 1095 577 1415 272 319 639 478 1101 478 476 0 851-165 1123-497 268-333 457-808 566-1425 109-620 165-1429 165-2431z"
      style={{
        fill: "#2b2a29",
        fillRule: "nonzero",
      }}
      className="fill"

    />
  </svg>
)
export default SvgComponent
